import type { Payload, UserGroupCallbacks } from './types'

export enum ActionType {
  NewMessage = 'NEW_MESSAGE',
  NewEvent = 'NEW_EVENT',
  NewUserGroupCallbacks = 'NEW_USER_GROUP_CALLBACKS',
}

export interface Action<T extends ActionType, P extends any> {
  type: T
  payload: P
}

type NewUserGroupCallbacks = Action<ActionType.NewUserGroupCallbacks, UserGroupCallbacks>

export const newUserGroupCallbacks = (
  userGroupCallbacks: UserGroupCallbacks,
): NewUserGroupCallbacks => ({
  type: ActionType.NewUserGroupCallbacks,
  payload: userGroupCallbacks,
})

type NewMessageAction = Action<ActionType.NewMessage, Payload>

export const newMessage = (payload: Payload): NewMessageAction => ({
  type: ActionType.NewMessage,
  payload,
})

type NewEventAction = Action<ActionType.NewEvent, Payload>

export const newEvent = (payload: Payload): NewEventAction => ({
  type: ActionType.NewEvent,
  payload,
})

export type Actions = NewMessageAction | NewEventAction | NewUserGroupCallbacks
